import React from 'react';
import PropTypes from 'prop-types';
import { useThemeContext } from "../../context/themeContext";

const Button = ({
    width,
    height,
    text,
    theme = 'solid',
    textColor = '#fff',
    onClick,
    fontSize = '1em',
    className,
    lineHeight,
    borderRadius
}) => {

    const handleClick = () => {
        if (onClick) {
        onClick();
        }
    };

    const { themeSetting } = useThemeContext()

    const gradient = `linear-gradient(to left, ${themeSetting.colors.primary}, ${themeSetting.colors.secondary}`;
    
    const style = {
        width: `${width}px`,
        height: `${height}px`,
        borderRadius: `${borderRadius}px`,
        color: `${textColor}`,
        border: 'none',
        padding: `10px`,
        fontSize: `${fontSize}`,
        lineHeight: `${lineHeight}`,
        backgroundImage: theme === 'gradient' && gradient,
        backgroundColor: theme === 'solid' && `${themeSetting.colors.primary}`,
    };

    return (
        <button style={style} className={`${className} font-face-poppins`} onClick={handleClick}>
         {text}
        </button>
    );
};

Button.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  text: PropTypes.string,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(['solid', 'gradient']),
  textColor: PropTypes.string,
};

export default Button;